
import React from 'react'

export const COLUMNS = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'silo',
    label: 'Silo',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'metrosDeVacio',
    label: 'Mts Vacio',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${(value !== null) ? parseFloat(value).toFixed(2) : 0}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Cap. Base Trigo [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Cap. Base Actual [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_TOTALES = [
  {
    name: 'cereal',
    label: 'Cereal',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad',
    options: {
      filter: true,
      sort: false
    }
  },
  {
    name: 'metrosDeVacioTotal',
    label: 'Mts Vacio',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${(value !== null) ? parseFloat(value).toFixed(2) : 0}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Cap. Base Trigo [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Cap. Base Actual [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio [tns]',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(2)}`}
          </div>
        )
      }
    }
  },
  {
    name: 'espacioTotalCamiones',
    label: 'Espacio Camiones',
    options: {
      filter: true,
      sort: false,
      customBodyRender: (value) => {
        return (
          <div style={{ textAlign: 'right', width: '80%' }}>
            {`${parseFloat(value).toFixed(0)}`}
          </div>
        )
      }
    }
  }
]

export const COLUMNS_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad'
  },
  {
    name: 'silo',
    label: 'Silo'
  },
  {
    name: 'metrosDeVacio',
    label: 'Mts Vacio'
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Cap. Base Trigo [tns]'
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Cap. Base Actual [tns]'
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [tns]'
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio [tns]'
  },
  {
    name: 'espacioTotalCamiones',
    label: 'Espacio Camiones'
  }
]

export const COLUMNS_TOTALES_TO_PRINT = [
  {
    name: 'cereal',
    label: 'Cereal'
  },
  {
    name: 'cerealVariedad',
    label: 'Variedad'
  },
  {
    name: 'silo',
    label: 'Silo'
  },
  {
    name: 'metrosDeVacio',
    label: 'Mts Vacio'
  },
  {
    name: 'pesoNetoTotalBaseTrigo',
    label: 'Cap. Base Trigo [tns]'
  },
  {
    name: 'pesoNetoTotalBaseVigente',
    label: 'Cap. Base Actual [tns]'
  },
  {
    name: 'pesoNetoBaseVigente',
    label: 'Existencia [tns]'
  },
  {
    name: 'espacioNetoTotal',
    label: 'Espacio [tns]'
  },
  {
    name: 'espacioTotalCamiones',
    label: 'Espacio Camiones'
  }
]
